export default "__VITE_ASSET__BYo3fE1K__"